<template>
  <section
    class="rounded-[24px] lg:rounded-[40px] bg-white p-6 lg:p-8 shadow-widget"
  >
    <div
      class="mx-auto grid max-w-[520px] justify-items-center gap-4 lg:gap-5 text-center"
    >
      <span
        class="grid h-12 w-12 place-items-center rounded-full bg-brand/10 text-brand lg:h-14 lg:w-14"
      >
        <svg class="h-6 w-6 lg:h-7 lg:w-7" aria-hidden="true">
          <use href="#ticket-widget-icon-calendar" />
        </svg>
      </span>

      <div>
        <h2
          class="m-0 text-lg lg:text-2xl font-semibold leading-[22px] lg:leading-7 text-ink"
        >
          Билетов на эту дату нет
        </h2>
        <p
          class="mt-2 text-sm lg:text-base font-medium leading-[18px] lg:leading-5 text-ink/60"
        >
          Выберите другую дату в календаре
        </p>
      </div>
    </div>
  </section>
</template>
